import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import {
  Link,
  AndrewBeharSignature
} from '../'
import Styles from './PlanScorecardCompanyLetter.css'


@CSSModules(Styles, {allowMultiple: true})
export default class CompanyLetter202302 extends Component {
  static propTypes = {
    letterConfig: PropTypes.object.isRequired,
    differentPage: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      differentPage: this.props.differentPage || false,
      companyName: this.props.letterConfig.companyName,
      companyPath: this.props.letterConfig.companyPath,
      letterDate: this.props.letterConfig.letterDate,
      addresseeSurname: this.props.letterConfig.addresseeSurname,
      addressee: this.props.letterConfig.addressee,
      aspirationalGoal: this.props.letterConfig.aspirationalGoal,
      asOfDate: this.props.letterConfig.asOfDate,
      defaultInvestmentName: this.props.letterConfig.defaultInvestmentName,
      noFewEsgOptions: this.props.letterConfig.noFewEsgOptions,
      planAssets: this.props.letterConfig.planAssets,
    }
  }

  render() {
    //
    return (
      <blockquote styleName='company-letter-blockquote'>

        <p><b>{this.state.letterDate}</b></p>

        <p><b>
        {this.state.addressee}
        <br/>
        {this.state.companyName}
        </b></p>

        <p><b>Re: {this.state.companyName} employee retirement plan sustainability scorecard</b></p>

        <p>Dear {this.state.addresseeSurname},</p>

        <p>{this.state.companyName} is known to be a leader on climate change, highlighted by {this.state.aspirationalGoal}.</p>

        <p><b>However, the company retirement plan directly contradicts all of this hard work on our operations.</b></p>

        <p>I am writing to inform you about the release of <i>As You Sow’s</i> retirement plan sustainability scorecard for {this.state.companyName}, and would like to extend an offer to meet and discuss our work. Below is a brief overview of the scorecard. </p>

        <p>The retirement plan sustainability scorecard is designed to empower the millions of U.S. employees holding trillions of dollars in retirement assets to invest their retirement savings sustainably. Many employees across the nation are unaware that their retirement plan savings are invested in climate change, prisons, weapons, and companies that score poorly on gender equality.</p>

        <p>We are using our <Link to={config.links.aysinvest} title='Invest Your Values - As You Sow' xstrong>expertise in mutual fund sustainability analysis</Link> and our extensive database of ESG-screened companies to rate employers’ retirement plan investment options across multiple environmental and social issues, including deforestation, climate, and gender equality.</p>

        {
          this.state.differentPage ?
            (
              <p><b><Link to={config.routes.plans + '/' + this.state.companyPath} title={this.state.companyName + ' retirement plan sustainability scorecard'} xstrong>The scorecard results for the {this.state.companyName} retirement plan</Link> demonstrates that the company is failing to address the material risks of climate change in its 401(k) plan.</b></p>
            ) :
            (
              <p><b><ScrollLink to='scores' spy title={this.state.companyName + ' retirement plan sustainability scorecard'} smooth offset={-50} duration={500}><span styleName='scroll-link'>The scorecard results for the {this.state.companyName} retirement plan</span></ScrollLink> demonstrates that the company is failing to address the material risks of climate change in its 401(k) plan.</b></p>
            )
        }

        <p>Since 1992, <i>As You Sow</i> has had great success helping companies to adopt beneficial policies and practices on a range of environmental, social, and governance issues. The time is ripe for {this.state.companyName} to show its leadership by aligning its sustainability goals holistically across both operations and its retirement plan. We commend {this.state.companyName} in its efforts to build a sustainable business for all stakeholders and the planet, including ambitious climate goals and implementing them with action.</p>

        <p>While the company has made significant efforts to address climate change across its operations, data from Department of Labor filings showing company retirement plan options and invested amounts suggest to investors that {this.state.companyName} has failed to address the material risks of climate change in its 401(k) plan in alignment with the duty to select retirement plan investment options in the best interests of plan participants and beneficiaries.</p>

        <p>{this.state.companyName} uses {this.state.defaultInvestmentName} as the default investment option in the 401(k) plan, and offers {this.state.noFewEsgOptions} sustainable climate-safe investment options. The result is that the majority of the {this.state.planAssets} of employee retirement dollars invested in the plan, as of {this.state.asOfDate}, invested in funds that hold companies that create substantial climate risk.</p>

        <p>Most employees assume the default option in their retirement plan is a safe choice. But if climate risk and other sustainability issues are not incorporated into the portfolio management by the fund manager, employees could be exposed to financial risks from unsustainable investments. Given the threat that climate change poses to workers’ life savings, {this.state.companyName} should demonstrate that it is safeguarding employee financial security over time by mitigating climate change-related financial and economic risks as part of a prudently constructed lineup of funds.</p>

        <p>Failing to satisfy this basic duty could be a liability for {this.state.companyName}, creating reputational risk and making it more difficult to retain employees increasingly concerned about catastrophic climate impacts.</p>

        {
          this.state.differentPage ?
            (
              <p><b>{this.state.companyName}'s retirement plan is rated Poor on multiple issue areas. The full results <Link to={config.routes.plans + '/' + this.state.companyPath} title={this.state.companyName + ' retirement plan sustainability scorecard'} xstrong>can be found here.</Link></b></p>
            ) :
            (
              <p><b>{this.state.companyName}'s retirement plan is rated Poor on multiple issue areas. The full results <ScrollLink to='scores' spy title={this.state.companyName + ' retirement plan sustainability scorecard'} smooth offset={-50} duration={500}><span styleName='scroll-link'>can be found here.</span></ScrollLink></b></p>
            )
        }

        <p>{this.state.companyName} has the opportunity to become an industry leader and help shift billions of dollars away from climate destruction and into companies that define the new economic paradigm in a safe, just, and sustainable world. We would appreciate the opportunity to meet with you and show you the details of our scorecard.</p>

        <p>Thank you for your time and consideration, and we look forward to hearing back from you.</p>

        <AndrewBeharSignature />

      </blockquote>
    )
  }
}